import React from 'react';
import type { OrderHangtagProps, OrderIndexPlatform } from '@hopdrive/feature-order-index';
import { createOrderIndexPlatform } from '@hopdrive/feature-order-index';

import PortalMoveTileHangtag from '@components/MoveTileHangtag';
import type { Hangtags } from '@gql/base-types';
import { copyToClipboard } from '@services/utilityService';

/** The portal's hangtag over the package's structural shape; the tag reads the same fields. */
const MoveTileHangtag: React.FC<OrderHangtagProps> = ({ hangtag }) => <PortalMoveTileHangtag hangtag={hangtag as unknown as Hangtags} />;

/**
 * The dealer's platform: the package's portal formatters, the dealer's own clipboard (the
 * package default copies silently; this one raises the portal's confirmation toast), and the
 * borrowed hangtag. One object for the app's lifetime.
 */
export const dealerOrderIndexPlatform: OrderIndexPlatform = createOrderIndexPlatform({ MoveTileHangtag, copyToClipboard });

/** A module constant, so it is stable across renders. */
export const useDealerOrderIndexPlatform = (): OrderIndexPlatform => dealerOrderIndexPlatform;
